<script>
  import _isEmpty from 'lodash/isEmpty'
  import VueElementLoading from 'vue-element-loading'
  import { checkVisibility } from '@utils/modal'

  export default {
    components: {
      VueElementLoading,
    },
    props: {
      type: {
        type: String,
        required: true
      },
      status: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        title: "Drag and drop a file here or browse to upload.",
        uploading: false,
      }
    },
    computed: {
      showLoader() {
        if (this.uploading && !_isEmpty(this.status)){
          return true
        }
        return false
      },
      disableToggles(){
        return ((!this.status.success) || (this.showLoader))
      }
    },
    watch: {
      status(newVal, oldVal){
        if (_isEmpty(newVal)){
          this.uploading = false
          this.$customModal.hide('import-excel')
        }
      }
    },
    methods: {
      checkVisibility,
      init() {
        this.title =  "Drag and drop a file here or browse to upload."
      },
      cancel() {
        this.$toasted.toast('Import cancelled. Your import was cancelled and your records have not been altered.', {
          title: `Import ${this.type}`,
          timer: 10000,
          variant: 'info',
          colour: 'blue',
        })
        this.$emit('onCancel');
      },
      onFileChange(e) {
        const files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          return
        }
        const file = files[0]
        this.title = file.name
        this.$emit('onFileChange', file)
      },
      importFile() {
        const files = this.$refs.file.files;
        if (!files.length) {
          return
        }
        const file = files[0]
        this.uploading = true
        this.$emit('onFileChange', file, 1)
      },
      downloadError() {
        const files = this.$refs.file.files;
        if (!files.length) {
          return
        }
        const file = files[0]
        this.title = file.name
        this.$emit('downloadError', file)
      },
      downloadTemplate() {
        this.$emit('downloadTemplate')
      },
    }
  };
</script>
<template>
  <FabricModal
    id="import-excel"
    title=""
    :no-close-on-backdrop="true"
    size="lg"
    hide-header
    modal-class="modal-custom-container"
    footer-class="!tw-p-4"
    @show="init"
    @shown="checkVisibility($event)"
  >
    <template v-slot:modal-body>
      <VueElementLoading :active="showLoader" spinner="bar-fade-scale"/>
      <section>
        <header
          class="
          modal-header
          tw-p-u tw-pb-4
          tw-border-b-2 tw-border-primary
          tw--mx-4">
          <section class="tw-px-4">
            <h3 class="title-d20-bb tw-text-gray-800">Import {{type}}</h3>
          </section>
        </header>
        <div class="modal-body-custom">
          <p class="tx-12 tx-gray-04 pd-t-20 tw-pb-2">Use the form below to import new {{type}}, <a href="#" @click="downloadTemplate"><span class="text-bold">Click here to download import template</span></a></p>
          <div class="main-form mg-t-0-f pd-0-f">
            <div class="form-group">
              <label class="label-control">Upload file</label>
              <div class="upload-box">
                <p class="text-field ml-2">{{title}}</p>
                <input
                  ref="file"
                  type="file"
                  class="form-control"
                  @change="onFileChange"/>
              </div>
            </div>
            <div class="form-group mg-b-0-f">
              <div v-if="status.success" class="success-block mg-t-10">
                <div class="left-content">
                  <span class="check-actived">
                    <span class="ficon-check"></span>
                  </span>
                </div>
                <div class="right-content">
                  <p class="des tx-15">Your file looks good!</p>
                  <p class="des tx-15">The import will create <span class="text-bold">{{status.success.success}} new {{type}}</span> update <span class="text-bold">{{status.success.update}} existing {{type}}</span> and error <span class="text-bold">{{status.success.error}} record {{type}}</span>.</p>
                  <p class="des tx-15 mg-b-0">Click <span class="text-bold">Confirm Import</span> to confirm these changes and <a href="#" @click="downloadError"><span class="text-bold">Click here to download error contents</span></a></p>
                </div>
              </div>
              <div v-if="status.error" class="error-block mg-t-10">
                <p class="des tx-15 mg-b-5">{{status.error.file}}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <template v-slot:modal-footer>
      <BaseContentFooter
        :is-positive-disabled="disableToggles"
        is-inside-modal
        update-text="Confirm Import"
        @footer-update="importFile"
        @footer-cancel="cancel"
      />
    </template>
  </FabricModal>
</template>
